/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint negative decision variants dictionary
 */
export enum FalconComplaintNegativeDecision {
  Scrapping = "Z",
  Return = "O"
}
